export function exportCsv(filename, rows, columns) {
  const header = columns.map((c) => `"${c.label}"`).join(",");
  const body = rows
    .map((r) =>
      columns
        .map((c) => {
          const v = typeof c.value === "function" ? c.value(r) : r[c.key];
          let s = v == null ? "" : String(v);
          // Neutralize CSV formula injection (Excel/Sheets) for cells starting with = + - @ tab CR
          if (/^[=+\-@\t\r]/.test(s)) s = "'" + s;
          return `"${s.replace(/"/g, '""')}"`;
        })
        .join(",")
    )
    .join("\n");
  const csv = "\uFEFF" + header + "\n" + body;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
